import { render, staticRenderFns } from "./reload-button.vue?vue&type=template&id=06c87f81&"
import script from "./reload-button.vue?vue&type=script&lang=js&"
export * from "./reload-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports